export enum FramedModalMessageType {
  // Modal -> Widget
  Ready = 'ready',
  FrameMount = 'frame-mount',
  TransitiveFromFrame = 'transitive-from-frame',
  Close = 'close',

  // Widget -> Modal
  Init = 'init',
  TransitiveToFrame = 'transitive-to-frame',
}

export enum CommonTransitiveMessageType {
  // Inner frame -> Widget
  RevalidateAppInstance = 'revalidate-app-instance',
  // Widget -> Inner frame
  RevalidateAppInstanceResult = 'revalidate-app-instance-result',
}

export interface FramedModalMessageInitPayload {
  url: string;
  title: string;
  // this prop is used when the page from "url" prop is not the same as the one that will be sending/receiving post messages
  // (e.g. in 3DS flow the "url" is some TPA Bank page, while we expect to "talk" with the "callback" page
  // "payment-completed" hosted on CDN)
  // the default value is the origin of the "url" prop
  // this is necessary to provide additional security when using post messaging
  callbackPageOrigin?: string;
}

export interface FramedModalMessage<T = any> {
  id: string;
  type: FramedModalMessageType;
  payload?: T;
}

export enum FramedModalType {
  Platform = 'platform',
  Custom = 'custom',
  CustomFullSize = 'custom-full-size',
}

export interface FramedModalQueryParams {
  // payment modal can be opened via WixSDK.openModal, which adds its own query params, that can potentially
  // collide with ours, thus hide them under payInfo param to reduce the risk of collision
  __modalParams: {
    id: string;
    widgetVersion?: string;
    widgetOrigin: string;
    modalType: FramedModalType;
    startTime: string;
    locale: string;
    userId: string;
  };
}
